// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from "jquery";
import "./partials/animations";
import "./partials/application-form";
import "./partials/countup";
import {
  initChocolatGalleries,
  watchGalleryContainers,
} from "./partials/images";
import "./partials/maps";

jQuery(document).ready(function ($) {
  initChocolatGalleries();

  // Sticky header scroll effect
  $(window).scroll(function () {
    if ($(this).scrollTop() > 50) {
      $("header").addClass("scrolled shadow");
    } else {
      $("header").removeClass("scrolled shadow");
    }
  });

  //$('.content img').addClass('shadow-bottom');

  $(".content")
    .find("h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5")
    .each(function () {
      $(this).addClass("underline");
    });

  $(".navbar-toggler").on("click", function () {
    $("#mobile-menu").addClass("active");
    $(".menu-overlay").css({ opacity: 1, visibility: "visible" });
  });

  $(".mobile-menu-close, .menu-overlay").on("click", function () {
    $("#mobile-menu").removeClass("active");
    $(".menu-overlay").css({ opacity: 0, visibility: "hidden" });
  });

  // active class in menu
  $(".navbar-nav .nav-item a")
    .filter(function () {
      return this.href == location.href;
    })
    .addClass("active")
    .attr("aria-current", "page");

  // Najpierw obsługa standardowych inputów (poza CF7)
  $('input[type="checkbox"]').each(function () {
    const $checkbox = $(this);
    const id = $checkbox.attr("id");
    const $label = $('label[for="' + id + '"]');

    if ($label.length && !$checkbox.closest(".custom-checkbox").length) {
      $checkbox.add($label).wrapAll('<div class="custom-checkbox"></div>');
      $checkbox.after('<span class="checkbox-box"></span>');
    }
  });

  $(".mobile-nav .menu-item-has-children > a").on("click", function (e) {
    e.preventDefault(); // Zawsze blokuj przejście – do testów
    console.log("Kliknięto element z submenu:", this);

    const $parent = $(this).parent();

    if (!$parent.hasClass("submenu-open")) {
      $parent.addClass("submenu-open");
      $parent.find("> .sub-menu").slideDown(200);
      console.log("Submenu otwarte.");
    } else {
      $parent.removeClass("submenu-open");
      $parent.find("> .sub-menu").slideUp(200);
      console.log("Submenu zamknięte.");
    }
  });

  // Dodatkowo obsługa Contact Form 7 checkboxów
  $(".wpcf7-list-item").each(function () {
    const $item = $(this);
    const $input = $item.find('input[type="checkbox"]');
    const $text = $item.find(".wpcf7-list-item-label");

    if (!$item.hasClass("custom-checkbox")) {
      $item.addClass("custom-checkbox");
      $input.after('<span class="checkbox-box"></span>');
    }
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js